import type { LiHTMLAttributes, ReactNode } from "react";

import * as styles from "./TrayColumns.styles";

interface Props extends LiHTMLAttributes<HTMLLIElement> {
  children: ReactNode;
}

const TrayColumnItem = ({ children, ...rest }: Props) => (
  <li css={styles.trayColumnItem} {...rest}>
    {children}
  </li>
);

export { TrayColumnItem };
